import React from 'react'
import userImg from '../../../assets/user-img.svg';
import { getTenantInfoByKey } from '../../../helpers/helpers';
import { useState } from 'react';
import PermanenceDetailModal from './PermanenceDetailModal';
import ItemSelectableSimple from '../../ItemSelectable/ItemSelectableSimple';
const PermanenceDetail = ({ report }) => {

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <PermanenceDetailModal
                showModal={showModal}
                setShowModal={() => setShowModal(!showModal)}
                report={report}
            />
            
            <ItemSelectableSimple onClick={() => setShowModal(!showModal)}>
                <div className='d-flex align-items-center gap-2'>
                    <img src={userImg}
                        alt={report.employee_natural_id}
                        style={{ width: '38px', height: '38px' }}
                    />
                    <div>
                        <span className='d-block blue-text'>
                            {report.employee_name}
                        </span>
                        <span className='d-block text-description'>
                            <strong>{getTenantInfoByKey('employee_id_lbl')} {report.employee_natural_id}</strong> | {report.contractor_name}
                        </span>
                    </div>
                </div>
            </ItemSelectableSimple>
        </>
    )
}

export default PermanenceDetail